module.exports = __webpack_public_path__ + "img/pic7.4b8bfc9e.jpg";